/**
 * Current portal version (X.Y.Z), sourced from the VITE_VERSION environment
 * variable (see .env) — the same value displayed as the version throughout the
 * portal. Bumping VITE_VERSION each release automatically updates this.
 *
 * When a new release ships:
 *   1. Bump VITE_VERSION in .env (and the deploy pipeline).
 *   2. Add a slide file at src/data/walkthroughs/{X.Y.Z}.js.
 *   3. Register it in src/data/walkthroughs/index.js.
 *
 * On login, WalkthroughGate compares this against the user's
 * `portal_version` (from core_user). If the user's version is lower,
 * the walkthrough modal is shown and acknowledgment is persisted via
 * apiSave so it doesn't repeat on other devices.
 */
export const CURRENT_PORTAL_VERSION = import.meta.env.VITE_VERSION;
